import { createFileRoute } from '@tanstack/react-router'
import { Animation } from '_/features/animation/ui/animation'

const AnimationPage = () => {
	return (
		<main className='flex min-h-dvh w-full items-center justify-center'>
			<Animation />
		</main>
	)
}

export const Route = createFileRoute('/animation')({
	staticData: { title: 'animation' },
	component: AnimationPage,
})
